<script setup lang="ts">
import { computed, getBreadCrumb } from '#imports'
import { useFetchTransactionInternalList } from '~/api/service/transaction/internal/list/index.service'
import ExpandItemTitle from '~/components/@pages/transactions/internal/ExpandItemTitle.vue'
import DetailsBox from '~/components/box/DetailsBox.vue'
import PageTitleHeader from '~/components/header/PageTitleHeader.vue'
import InternalTransactionsTable from '~/components/table/transactions-internal/InternalTransactionsTable.vue'
import BcExpand from '~/ui/Expand/BcExpand.vue'
import BcPagination from '~/ui/Pagination/BcPagination.vue'

const { pagination, rowPerPageList } = usePagination({
  page: 1,
  rowPerPage: 15
})

const { data, isLoading } = useFetchTransactionInternalList(pagination)

const loadingList = computed(() => {
  return Array.from({ length: pagination.value.rowPerPage }, () => undefined)
})

useSeoMeta(getMeta('Internal Transactions', 'View the blockchain internal transactions'))

useHead(getBreadCrumb())
</script>

<template>
  <PageTitleHeader title="Internal Transactions" />
  <DetailsBox class="my-4">
    Showing the last <span class="font-bold text-primary">{{ data?.viewCount }}</span> records from {{
      data?.totalCount
    }} results
    <template #pagination>
      <BcPagination
        v-if="data?.VCNT"
        v-model="pagination"
        :row-per-page-list="rowPerPageList"
        :total-count="data?.VCNT"
        hide-rows-per-page
      />
    </template>
  </DetailsBox>

  <Card
    v-for="(item, idx) in data?.internalTrxGroupList || loadingList"
    :key="item?.BNO || idx"
    class="mb-2"
  >
    <BcExpand
      :expand="idx === 0"
    >
      <template #title>
        <ExpandItemTitle
          :block-number="item?.BNO"
          :ago="item?.AG"
          :transaction-cnt="item?.TRXCNT"
          :is-loading="isLoading"
        />
      </template>
      <template #body>
        <InternalTransactionsTable
          :rows="item?.internalTrxList || []"
          :is-loading="isLoading"
        />
      </template>
    </BcExpand>
  </Card>

  <BcPagination
    v-if="data?.VCNT"
    v-model="pagination"
    :row-per-page-list="rowPerPageList"
    :total-count="data?.VCNT"
    hide-rows-per-page
  />
</template>

<style scoped>

</style>
